// src/constants/data.js

export const sports = [
  'NRL',
  'AFL',
  'Soccer',
  'NBA',
  'NFL',
  'MLB',
  'UFC',
  'Tennis'
];

export const leagueData = {
  'NRL': {
    leagues: {
      'NRL': [
        'Brisbane Broncos',
        'Canberra Raiders',
        'Canterbury-Bankstown Bulldogs',
        'Cronulla-Sutherland Sharks',
        'Gold Coast Titans',
        'Manly Warringah Sea Eagles',
        'Melbourne Storm',
        'Newcastle Knights',
        'New Zealand Warriors',
        'North Queensland Cowboys',
        'Parramatta Eels',
        'Penrith Panthers',
        'South Sydney Rabbitohs',
        'St. George Illawarra Dragons',
        'Sydney Roosters',
        'Wests Tigers',
        'Dolphins'
      ]
    }
  },
  'AFL': {
    leagues: {
      'AFL': [
        'Adelaide Crows',
        'Brisbane Lions',
        'Carlton',
        'Collingwood',
        'Essendon',
        'Fremantle',
        'Geelong Cats',
        'Gold Coast Suns',
        'Greater Western Sydney Giants',
        'Hawthorn',
        'Melbourne',
        'North Melbourne',
        'Port Adelaide',
        'Richmond',
        'St Kilda',
        'Sydney Swans',
        'West Coast Eagles',
        'Western Bulldogs'
      ]
    }
  },
  'Soccer': {
    leagues: {
      'EPL': [
        'Arsenal',
        'Aston Villa',
        'Bournemouth',
        'Brentford',
        'Brighton & Hove Albion',
        'Chelsea',
        'Crystal Palace',
        'Everton',
        'Fulham',
        'Ipswich Town',
        'Leicester City',
        'Liverpool',
        'Manchester City',
        'Manchester United',
        'Newcastle United',
        'Nottingham Forest',
        'Southampton',
        'Tottenham Hotspur',
        'West Ham United',
        'Wolverhampton Wanderers'
      ],
      'La Liga': [
        'Athletic Bilbao',
        'Atletico Madrid',
        'Barcelona',
        'Real Madrid',
        'Sevilla',
        'Valencia',
        'Villarreal',
        'Real Sociedad',
        'Real Betis',
        'Osasuna',
        'Celta Vigo',
        'Mallorca',
        'Girona',
        'Las Palmas',
        'Alaves',
        'Getafe',
        'Espanyol',
        'Leganes',
        'Rayo Vallecano',
        'Real Valladolid'
      ],
      'Serie A': [
        'AC Milan',
        'Inter Milan',
        'Juventus',
        'Napoli',
        'AS Roma',
        'Lazio',
        'Atalanta',
        'Fiorentina',
        'Bologna',
        'Torino',
        'Udinese',
        'Sassuolo',
        'Empoli',
        'Hellas Verona',
        'Salernitana',
        'Spezia',
        'Sampdoria',
        'Cremonese',
        'Lecce',
        'Monza'
      ],
      'Bundesliga': [
        'Bayern Munich',
        'Borussia Dortmund',
        'RB Leipzig',
        'Union Berlin',
        'SC Freiburg',
        'Bayer Leverkusen',
        'Eintracht Frankfurt',
        'VfL Wolfsburg',
        'FSV Mainz 05',
        'Borussia Monchengladbach',
        'FC Koln',
        'TSG Hoffenheim',
        'FC Augsburg',
        'VfB Stuttgart',
        'Hertha Berlin',
        'Arminia Bielefeld',
        'VfL Bochum',
        'Greuther Furth'
      ],
      'Ligue 1': [
        'Paris Saint-Germain',
        'Marseille',
        'AS Monaco',
        'Lyon',
        'Nice',
        'Lille',
        'Rennes',
        'Nantes',
        'Montpellier',
        'Strasbourg',
        'Lens',
        'Brest',
        'Reims',
        'Clermont',
        'Lorient',
        'Angers',
        'Troyes',
        'Saint-Etienne',
        'Bordeaux',
        'Metz'
      ],
      'Super Lig': [
        'Galatasaray',
        'Fenerbahce',
        'Besiktas',
        'Trabzonspor',
        'Basaksehir',
        'Alanyaspor',
        'Sivasspor',
        'Konyaspor',
        'Gaziantep FK',
        'Kayserispor',
        'Antalyaspor',
        'Hatayspor',
        'Kasimpasa',
        'Giresunspor',
        'Fatih Karagumruk',
        'Adana Demirspor',
        'Altay',
        'Yeni Malatyaspor'
      ],
      'Eredivisie': [
        'Ajax',
        'PSV Eindhoven',
        'Feyenoord',
        'AZ Alkmaar',
        'FC Utrecht',
        'Vitesse',
        'FC Twente',
        'Sparta Rotterdam',
        'SC Heerenveen',
        'Willem II',
        'FC Groningen',
        'PEC Zwolle',
        'Heracles',
        'Fortuna Sittard',
        'Go Ahead Eagles',
        'NEC Nijmegen',
        'RKC Waalwijk',
        'Cambuur'
      ],
      'Scottish Premiership': [
        'Celtic',
        'Rangers',
        'Aberdeen',
        'Hearts',
        'Hibernian',
        'Dundee United',
        'Motherwell',
        'St Johnstone',
        'Ross County',
        'Livingston',
        'St Mirren',
        'Kilmarnock'
      ],
      'Brasileirao': [
        'Flamengo',
        'Palmeiras',
        'Atletico Mineiro',
        'Sao Paulo',
        'Fluminense',
        'Internacional',
        'Corinthians',
        'Gremio',
        'Santos',
        'Vasco da Gama',
        'Botafogo',
        'Atletico Paranaense',
        'Cruzeiro',
        'Fortaleza',
        'Bahia',
        'Goias',
        'Coritiba',
        'America Mineiro',
        'Cuiaba',
        'Bragantino'
      ],
      'J-League': [
        'Yokohama F. Marinos',
        'Kawasaki Frontale',
        'Gamba Osaka',
        'Urawa Red Diamonds',
        'FC Tokyo',
        'Cerezo Osaka',
        'Sanfrecce Hiroshima',
        'Kashima Antlers',
        'Vissel Kobe',
        'Nagoya Grampus',
        'Kashiwa Reysol',
        'Shonan Bellmare',
        'Avispa Fukuoka',
        'Consadole Sapporo',
        'Kyoto Sanga',
        'Sagan Tosu',
        'Jubilo Iwata',
        'Machida Zelvia'
      ],
      'MLS': [
        'Atlanta United',
        'Austin FC',
        'Charlotte FC',
        'Chicago Fire',
        'FC Cincinnati',
        'Colorado Rapids',
        'Columbus Crew',
        'DC United',
        'FC Dallas',
        'Houston Dynamo',
        'Inter Miami',
        'LA Galaxy',
        'LAFC',
        'Minnesota United',
        'Montreal Impact',
        'Nashville SC',
        'New England Revolution',
        'New York City FC',
        'New York Red Bulls',
        'Orlando City',
        'Philadelphia Union',
        'Portland Timbers',
        'Real Salt Lake',
        'San Jose Earthquakes',
        'Seattle Sounders',
        'Sporting Kansas City',
        'Toronto FC',
        'Vancouver Whitecaps'
      ],
      'A-League': [
        'Adelaide United',
        'Brisbane Roar',
        'Central Coast Mariners',
        'Macarthur FC',
        'Melbourne City',
        'Melbourne Victory',
        'Newcastle Jets',
        'Perth Glory',
        'Sydney FC',
        'Wellington Phoenix',
        'Western Sydney Wanderers',
        'Western United'
      ]
    }
  },
  'NBA': {
    leagues: {
      'NBA': [
        'Atlanta Hawks',
        'Boston Celtics',
        'Brooklyn Nets',
        'Charlotte Hornets',
        'Chicago Bulls',
        'Cleveland Cavaliers',
        'Dallas Mavericks',
        'Denver Nuggets',
        'Detroit Pistons',
        'Golden State Warriors',
        'Houston Rockets',
        'Indiana Pacers',
        'LA Clippers',
        'Los Angeles Lakers',
        'Memphis Grizzlies',
        'Miami Heat',
        'Milwaukee Bucks',
        'Minnesota Timberwolves',
        'New Orleans Pelicans',
        'New York Knicks',
        'Oklahoma City Thunder',
        'Orlando Magic',
        'Philadelphia 76ers',
        'Phoenix Suns',
        'Portland Trail Blazers',
        'Sacramento Kings',
        'San Antonio Spurs',
        'Toronto Raptors',
        'Utah Jazz',
        'Washington Wizards'
      ]
    }
  },
  'NFL': {
    leagues: {
      'NFL': [
        'Arizona Cardinals',
        'Atlanta Falcons',
        'Baltimore Ravens',
        'Buffalo Bills',
        'Carolina Panthers',
        'Chicago Bears',
        'Cincinnati Bengals',
        'Cleveland Browns',
        'Dallas Cowboys',
        'Denver Broncos',
        'Detroit Lions',
        'Green Bay Packers',
        'Houston Texans',
        'Indianapolis Colts',
        'Jacksonville Jaguars',
        'Kansas City Chiefs',
        'Las Vegas Raiders',
        'Los Angeles Chargers',
        'Los Angeles Rams',
        'Miami Dolphins',
        'Minnesota Vikings',
        'New England Patriots',
        'New Orleans Saints',
        'New York Giants',
        'New York Jets',
        'Philadelphia Eagles',
        'Pittsburgh Steelers',
        'San Francisco 49ers',
        'Seattle Seahawks',
        'Tampa Bay Buccaneers',
        'Tennessee Titans',
        'Washington Commanders'
      ]
    }
  },
  'MLB': {
    leagues: {
      'MLB': [
        'Arizona Diamondbacks',
        'Atlanta Braves',
        'Baltimore Orioles',
        'Boston Red Sox',
        'Chicago Cubs',
        'Chicago White Sox',
        'Cincinnati Reds',
        'Cleveland Guardians',
        'Colorado Rockies',
        'Detroit Tigers',
        'Houston Astros',
        'Kansas City Royals',
        'Los Angeles Angels',
        'Los Angeles Dodgers',
        'Miami Marlins',
        'Milwaukee Brewers',
        'Minnesota Twins',
        'New York Mets',
        'New York Yankees',
        'Oakland Athletics',
        'Philadelphia Phillies',
        'Pittsburgh Pirates',
        'San Diego Padres',
        'San Francisco Giants',
        'Seattle Mariners',
        'St. Louis Cardinals',
        'Tampa Bay Rays',
        'Texas Rangers',
        'Toronto Blue Jays',
        'Washington Nationals'
      ]
    }
  },
  'UFC': {
    leagues: {
      'UFC': [] // No predefined teams/fighters - everything manual
    }
  },
  'Tennis': {
    leagues: {
      'Major Tournaments': [
        'Australian Open',
        'French Open',
        'Wimbledon',
        'US Open',
        'ATP Finals',
        'WTA Finals',
        'Indian Wells',
        'Miami Open',
        'Monte Carlo Masters',
        'Madrid Open',
        'Italian Open',
        'Canadian Open',
        'Cincinnati Masters',
        'Shanghai Masters',
        'Paris Masters'
      ]
    }
  }
};

export const betTypes = {
  'NRL': [
    'Match Winner',
    'Line Betting',
    'Total Points',
    'First Try Scorer',
    'Anytime Try Scorer',
    'Winning Margin',
    'Half Time/Full Time',
    'Player Performance'
  ],
  'AFL': [
    'Match Winner',
    'Line Betting',
    'Total Points',
    'First Goal Scorer',
    'Anytime Goal Scorer',
    'Winning Margin',
    'Quarter/Half Time Winner',
    'Player Performance'
  ],
  'Soccer': [
    'Match Winner',
    'Both Teams to Score',
    'Over/Under Goals',
    'Correct Score',
    'First Goal Scorer',
    'Anytime Goal Scorer',
    'Asian Handicap',
    'Double Chance',
    'Half Time/Full Time'
  ],
  'NBA': [
    'Match Winner',
    'Point Spread',
    'Total Points',
    'Player Points',
    'Player Assists',
    'Player Rebounds',
    'Quarter Winner',
    'First Basket'
  ],
  'NFL': [
    'Match Winner',
    'Point Spread',
    'Total Points',
    'Player Touchdowns',
    'Player Passing Yards',
    'Player Rushing Yards',
    'First Touchdown Scorer',
    'Quarter Winner'
  ],
  'MLB': [
    'Match Winner',
    'Run Line',
    'Total Runs',
    'First Inning Winner',
    'Player Home Runs',
    'Player RBIs',
    'Player Hits',
    'Player Strikeouts',
    'Inning Betting'
  ],
  'UFC': [
    'Fight Winner',
    'Method of Victory',
    'Round Betting',
    'Over/Under Rounds',
    'Fight to Go Distance'
  ],
  'Tennis': [
    'Match Winner',
    'Set Betting',
    'Game Handicap',
    'Total Games',
    'First Set Winner',
    'Retirement/Walkover'
  ]
};